<template>
  <BaseLoader v-if="!$store.getters.isLoaded(['products', 'shelves'])" />
  <div v-else>
    <ProductTeaser :productId="product.id" v-blur-on-click style="margin: 2rem 0 1rem" />
    <StockListing :items="stocks" @item-selected="openEditStockLayer" @store-button-click="openStoreLayer" />
    <EANEditor :product="product" />
    <AddStockLayer v-if="addStockLayerVisible" :initialProductId="product.id" @close="addStockLayerVisible = false" />
    <EditStockLayer
      v-if="editStockLayerSpaceId"
      :product="product"
      :productId="this.$route.params.productId"
      :shelfSpaceId="editStockLayerSpaceId"
      openLink="shelf"
      @close="editStockLayerSpaceId = null"
    />
    <Scanner v-if="!addStockLayerVisible" />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner'
import ProductTeaser from '@/components/ProductTeaser'
import StockListing from '@/components/StockListing'
import AddStockLayer from '@/components/Stock/AddStockLayer'
import EditStockLayer from '@/components/Stock/EditStockLayer'
import EANEditor from '@/components/EANEditor'
import { Stocks } from '@/helpers/Calculator'

export default {
  components: { Scanner, ProductTeaser, StockListing, AddStockLayer, EditStockLayer, EANEditor },
  data() {
    return {
      addStockLayerVisible: false,
      editStockLayerSpaceId: null
    }
  },
  computed: {
    productId() {
      return this.$route.params.productId
    },
    product() {
      return _.find(this.$store.state.products, { id: this.productId })
    },
    stocks() {
      return Stocks(this.productId, this.$store.state.shelves)
    }
  },
  methods: {
    openEditStockLayer(item) {
      this.editStockLayerSpaceId = item.shelfSpaceId
    },
    openStoreLayer() {
      this.addStockLayerVisible = true
    }
  }
}
</script>
